import { Injectable, Injector } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { Subcategory } from '../models/subcategory.model';


@Injectable({ providedIn: 'root' })

export class SubcategoryService extends BaseService<Subcategory>{
   
    constructor(
        protected injector: Injector,
    ){
        super(injector);
        this.copyJsonDataToObjectFunction=Subcategory.fromJsonToObject
        this.urls={getAllUrl:'subcategories',saveUrl:'regSubcategoria',updateUrl:'up-subcategoria',deleteUrl:'dst-subcategoria'}
    }

}